import { render, staticRenderFns } from "./AccountAdoptionTab.vue?vue&type=template&id=8e353474&scoped=true"
import script from "./AccountAdoptionTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountAdoptionTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountAdoptionTab.vue?vue&type=style&index=0&id=8e353474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e353474",
  null
  
)

export default component.exports